<template>
  <div class="main-header-area">
    <div class="content auto-max-width">
      <div class="help-center">
        <a href="https://help.icrobotics.com" target="_blank" tooltip="Helpcenter" tooltip-placement="left">
          <span class="help-center-text">
            {{$t('need-help')}}
          </span>
          <span class="help-center-icon">
            <img src="@/assets/svg/circle-question-solid.svg" alt="helpcenter icon" />
          </span>
        </a>
      </div>
      <div class="main-content-wrapper ">
        <h1>{{ title }}</h1>
        <slot name="main"></slot>
      </div>

      <div class="menu-content-wrapper">
        <slot name="menu"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less">
.main-header-area {
  position: relative;
  background-color: #fff;
  padding: 0 24px 0 calc(var(--sidebar-width) + 24px);
  .content {
    min-height: 200px;
    padding: 36px 12px 0 12px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .help-center {
      cursor: pointer;
      position: absolute;
      right: 12px;
      top: 36px;
      font-size: 18px;
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
      }
      .help-center-text {
        font-size: 12px;
      }
      .help-center-icon {
        img {
          width: 18px; 
        }
      }
    }

    .main-content-wrapper {
      max-width: 450px;
    }

    .menu-content-wrapper {
      // align-self: end;
    }
  }
}

@media screen and (min-width: var(--auto-max-width)) {
  .main-header-area {
    padding-left: var(--sidebar-width);
  }
}

@media screen and (max-width: 620px) {
  .main-header-area {
    padding: 60px 18px 0 18px;
  }
}
</style>
